import { useTranslation } from "react-i18next";
import { cn } from "@/shared/lib/cn";
import { Badge } from "../badge";

/** "-15%" (red) and "Новинка" (green) pills. */
export function Badges({
  discountPercent,
  isNew,
  className,
}: {
  discountPercent?: number | null;
  isNew: boolean;
  className?: string;
}) {
  const { t } = useTranslation();
  if (!discountPercent && !isNew) return null;
  return (
    <div className={cn("flex gap-1", className)}>
      {discountPercent ? (
        <Badge tone="danger" size="sm" pill>
          −{discountPercent}%
        </Badge>
      ) : null}
      {isNew && (
        <Badge tone="success" size="sm" pill>
          {t("product.new")}
        </Badge>
      )}
    </div>
  );
}
